module.exports = __webpack_public_path__ + "static/media/zwzhome2.85bf0902.jpg";